import React from "react";
import { Descriptions } from "antd";
import style from "./index.module.scss";
import { GradeRuleModelType } from "../../../../API/scoreRule";
import FormulaModeColumn from "./Components/FormulaModeColumn/index";

interface Iprops {
    list: GradeRuleModelType[]; //元数据
    ruleCourseName: string;
    loading: boolean;
}

const Index: React.FC<Iprops> = ({ list: dataSource, loading }) => {
    return (
        <div className={style.root}>
            {dataSource.map(item => (
                <Descriptions
                    bordered
                    className={style.margin}
                    size="small"
                    key={item.id}
                    column={4}>
                    <Descriptions.Item label="考核模块" span={2}>
                        <p className={style.sp}>{item.ruleName}</p>
                    </Descriptions.Item>
                    <Descriptions.Item label="权重%" span={2}>
                        <p className={style.sp}>{item.weight}</p>
                    </Descriptions.Item>
                    <Descriptions.Item label="成绩规则" span={4}>
                        <p className={style.sp}>{item.description}</p>
                    </Descriptions.Item>
                    <Descriptions.Item label="成绩细则" span={4}>
                        <div className={style.text}>
                            {!item?.formulaModeJson && "无"}
                            <FormulaModeColumn
                                value={item.formulaModeJson}
                                isShow
                                record={item}
                            />
                        </div>
                    </Descriptions.Item>
                    <Descriptions.Item label="备注" span={4}>
                        {!item?.remark && "无"}
                        <p className={style.text}>{item.remark}</p>
                    </Descriptions.Item>
                </Descriptions>
            ))}
        </div>
    );
};

export default Index;
